export default "__VITE_ASSET__C0rLK_Hv__"